// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.grid-size{
    width: 98%;
    margin-left: 15px;
}
  ::ng-deep .add-engagement label, .add-engagement p.normal-text { 
   bottom: 0 !important;
  }

  .custom-hover-button:hover {
    background-color:rgb(222, 222, 222) !important;
    border-color: rgb(204, 204, 204) !important;
  }`, "",{"version":3,"sources":["webpack://./src/app/features/engagement/viewsingle/view-singleengagement.component.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,iBAAiB;AACrB;EACE;GACC,oBAAoB;EACrB;;EAEA;IACE,8CAA8C;IAC9C,2CAA2C;EAC7C","sourcesContent":[".grid-size{\r\n    width: 98%;\r\n    margin-left: 15px;\r\n}\r\n  ::ng-deep .add-engagement label, .add-engagement p.normal-text { \r\n   bottom: 0 !important;\r\n  }\r\n\r\n  .custom-hover-button:hover {\r\n    background-color:rgb(222, 222, 222) !important;\r\n    border-color: rgb(204, 204, 204) !important;\r\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
